import classnames from 'classnames';
import React from 'react';

const Checkbox = ({ facetValue, facetTypeHeader, handleChange }) => {
	if (facetValue && facetTypeHeader && handleChange) {
		const facetId = `facet_${facetValue.FriendlyName}`;

		return (
			<div className="flex items-center px-4 py-3 md:py-1 relative">
				<a href={facetValue.Url} className="flex" tabIndex="-1">
					<label
						htmlFor={`${facetTypeHeader}-${facetId}-${facetValue.Name}`}
						className="facet-type__label c-input-checkbox inline-flex mr-3 md:-ml-2">
						<input
							type="checkbox"
							id={`${facetTypeHeader}-${facetId}-${facetValue.Name}`}
							name={facetTypeHeader}
							value={facetValue.Name}
							onChange={(e) => handleChange(e)}
							checked={facetValue.Selected}
						/>
						<span className="c-input__grid flex items-start">
							<span className="c-input__controls facet-value__custom-facet-scale text-ongreen">
								<span
									className={classnames('c-input-checkbox-bg w-6 h-6', {
										'bg-ongreen border-ongreen': facetValue.Selected,
									})}
								/>
								<span className="icon-tick2 text-xs" />
							</span>
							<span className="c-input__label pl-3 md:pl-0">
								<span className="facet-type__label-name text-body-sm md:text-xs mr-1">
									{facetValue.Name}
								</span>

								{facetValue.Total > 0 && (
									<span className="facet-type__label-total text-body-sm md:text-xs inline-block">
										({facetValue.Total})
									</span>
								)}
							</span>
						</span>
					</label>
				</a>
			</div>
		);
	}

	return null;
};

export default Checkbox;
